import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  deleteTanqueFisico,
  findTanqueFisico,
  recordFiltering,
} from '~/store/modules/tanquefisico/actions';
import Form from './form';

function CadastroTanqueFisico() {
  const data = useSelector((state) => state.tanquefisico);

  const listaStatusPesquisa = useMemo(
    () => [
      { label: 'liberado', value: 'liberado' },
      { label: 'bloqueado', value: 'bloqueado' },
      { label: 'cancelado', value: 'cancelado' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'tafi_codigo',
        label: 'Código',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'tafi_nome',
        label: 'Descrição',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'tavi_nome',
        label: 'Tanque Virtual',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'tafi_capacidade',
        label: 'Capacidade',
        align: 'right',
      },
      {
        id: 'tafi_ip_concentrador',
        label: 'IP',
        align: 'left',
      },
      {
        id: 'tafi_numero_sonda',
        label: 'Sonda',
        align: 'center',
      },
      {
        id: 'tafi_automatico_string',
        label: 'Automático',
        align: 'center',
      },
      {
        id: 'arqu_descricao',
        label: 'Arqueação',
        align: 'center',
      },

      {
        id: 'tafi_status_string',
        label: 'Status',
        align: 'center',
        filter: {
          type: 'select',
          options: listaStatusPesquisa,
        },
      },
    ],
    []
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="tafi_codigo ASC"
      fixed
      read={recordFiltering}
      find={findTanqueFisico}
      remove={deleteTanqueFisico}
      form={Form}
      header={header}
      redux={data}
      detach="tafi_nome"
      keys={['tafi_codigo', 'poco_codigo', 'tavi_codigo']}
      view="VW_TB_TANQUEFISICO"
      reportTitle="Cadastro de Tanque Físico"
    />
  );
}

export default CadastroTanqueFisico;
